import { authentication, authorization } from "@smri-its/omni-utils"
import { AUTH_URL, APP_NAME } from "../../../constants"

const { localStorage, location } = window
const { getUser } = authentication

const logout = async () => {
  const cbUrl = location.href
    .split("/")
    .slice(0, 3)
    .join("/")

  localStorage.clear()
  location.href = `${AUTH_URL}/logout?cbUrl=${cbUrl}&appName=${APP_NAME}`
  return true
}

export const isTreasury = ( ) => {
  const user = getUser()
  const matches = user.authorizations.filter( element => {
    return ["Treasury", "Admin"].includes( element["roleName"] );
  });
  return (matches.length > 0);
}

export const isAccounting = ( ) => {
  const user = getUser()
  const matches = user.authorizations.filter( element => {
    return ["Treasury", "Accounting", "Admin"].includes( element["roleName"] );
  });
  return (matches.length > 0);
}

export const isAdmin = ( ) => {
  const user = getUser()
  const matches = user.authorizations.filter( element => {
    return ["Admin"].includes( element["roleName"] );
  });
  return (matches.length > 0);
}

const AuthenticationUtil = {
  ...authentication,
  ...authorization,
  logout,
};

export default AuthenticationUtil;
